'use client';

import { useEffect } from 'react';
import { useUnit } from 'effector-react';
import { Head } from '@nx-frontend/shared/ui';
import { Spinner } from '@nx-frontend/shared/ui/spinner';
import { $currentWorkspace } from '@nx-frontend/shared/store/current-workspace';
import { $orgChat, checkChatInitializationEvent } from '@nx-frontend/shared/store/org-chat';
import { ChatWithWebComponent } from './chat-with-web-component';

export function Chat() {
  const [orgChat, currentWorkspace] = useUnit([$orgChat, $currentWorkspace]);
  const [checkChatInitialization] = useUnit([checkChatInitializationEvent]);

  useEffect(() => {
    checkChatInitialization();
  }, [checkChatInitialization]);

  const pageTitle = `Chat - ${currentWorkspace.title}`;

  return (
    <>
      <Head>
        <title>{pageTitle}</title>
      </Head>
      <div className="h-full w-full">
        {!orgChat.initilized ? (
          <div className="h-full w-full flex justify-center items-center flex-col">
            {orgChat.initilized === false ? (
              <div className="max-w-[707px] text-center mb-1">
                We are initializing the chat to run in your organization. This will only be done once and will not take
                a long time.
              </div>
            ) : null}
            <Spinner />
          </div>
        ) : (
          <ChatWithWebComponent />
        )}
      </div>
    </>
  );
}
